export const en = {
    popup_hint: 'From here you can go to the applications of other business trip participants',
};
